module.exports = __webpack_public_path__ + "img/img2.cb63651a.png";